import { useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import ScrollToTop from "./components/scrollTop/ScrollTop";
import ModalWrapper from "./components/modalWrapper";
import FloatingButtons from "./components/floating-buttons";
import ClutchIcon from "./components/clutch-icon";
import { routes } from "./routes";
import ProtectedRoute from "./protectedRoutes";
import Loader from "./components/loader";
import Cookies from "universal-cookie";
import { useDispatch, useSelector } from "react-redux";
import { clearCountry, setCountry } from "./redux/slices/countrySlice";
import Chatbot from "./components/chat/Chatbot";
import i18n from "./18n";
import FloatingBar from "./components/floating-bar/FloatingBar";
import RouteTracker from "./components/RouteTracker/RouteTracker";

const cookies = new Cookies();
function App() {
  const [region, setRegion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAccepted, setIsAccepted] = useState(cookies.get("cookiesAccepted"));
  const dispatch = useDispatch();
  const location = useLocation();
  const checkContactUsPage = location.pathname;

  // const allowedCountries = ["us", "ksa", "au", "uae"];
  // const currentCountryFromUrl = allowedCountries.find((country) =>
  //   location.pathname.includes(`/${country}`)
  // );

  // useEffect(() => {
  //   const handleRightClick = (e) => {
  //     e.preventDefault();
  //   };

  //   document.addEventListener("contextmenu", handleRightClick);

  //   return () => {
  //     document.removeEventListener("contextmenu", handleRightClick);
  //   };
  // }, []);

  // useEffect(() => {
  //   const fetchLocation = async () => {
  //     try {
  //       const ipRes = await fetch("https://api.ipify.org?format=json");
  //       const ip = await ipRes.json();
  //       console.log("ip =>", ip);

  //       // const res = await fetch("https://ipinfo.io/json?token=1c7e1e8c73e2f2");
  //       // const res = await fetch(
  //       //   "https://api.ipgeolocation.io/ipgeo?apiKey=db3c8a9550b5452682291fd1ef4ea026"
  //       // );
  //       const res = await fetch(`https://api.iplocation.net/?ip=${ip?.ip}`);
  //       const data = await res.json();
  //       console.log(data, "country data here");

  //       // const countryCode = data.country; // Correct key from ipinfo.io
  //       const countryCode = data.country_code2; // Correct key from ipinfo.io

  //       console.log(
  //         "condition =>",
  //         currentCountryFromUrl && countryCode !== "PK"
  //       );

  //       if (currentCountryFromUrl) {
  //         setRegion(currentCountryFromUrl);
  //         dispatch(setCountry(currentCountryFromUrl));
  //         return;
  //       } else {
  //         if (countryCode === "PK") {
  //           setRegion("us");
  //           dispatch(setCountry("us"));
  //         } else if (countryCode === "SA") {
  //           setRegion("ksa");
  //           dispatch(setCountry("ksa"));
  //           i18n.changeLanguage("ar");
  //           document.documentElement.setAttribute("dir", "rtl");
  //         } else if (countryCode === "US") {
  //           setRegion("us");
  //           dispatch(setCountry("us"));
  //         } else if (countryCode === "AU") {
  //           setRegion("au");
  //           dispatch(setCountry("au"));
  //         } else if (countryCode === "AE") {
  //           setRegion("uae");
  //           dispatch(setCountry("uae"));
  //         } else {
  //           setRegion("");
  //           dispatch(clearCountry());
  //         }
  //       }

  //       handleChaneLang();
  //     } catch (error) {
  //       console.error("Error fetching location:", error);
  //       setRegion("");
  //       dispatch(clearCountry());
  //     } finally {
  //       handleChaneLang();
  //       setLoading(false);
  //     }
  //   };

  //   fetchLocation();
  // }, []);

  // const handleChaneLang = () => {
  //   const location = localStorage.getItem("country");
  //   // alert("checking");

  //   if (location === "ksa") {
  //     i18n.changeLanguage("ar");
  //     document.documentElement.setAttribute("dir", "rtl");
  //   } else {
  //     i18n.changeLanguage("en");
  //   }
  // };

  // console.log("region =>", region);

  // if (loading) return <Loader />; // Show loading while fetching location
  return (
    <>
      <ScrollToTop />
      {checkContactUsPage !== "/contact-us" && (
        <ClutchIcon isAccepted={isAccepted} setIsAccepted={setIsAccepted} />
      )}
      {/* <ModalWrapper setIsAccepted={setIsAccepted} /> */}
      {checkContactUsPage !== "/contact-us" && <FloatingButtons />}
      {checkContactUsPage !== "/contact-us" && checkContactUsPage !== "/lead-magnet" && checkContactUsPage !== "/solutions/auraclinic" && <FloatingBar />}
      {/* <Chatbot /> */}
      <RouteTracker />
      <Routes>
        {routes.map(({ path, element }) => (
          <Route
            key={path}
            path={path}
            element={element}
          // element={<ProtectedRoute region={region}>{element}</ProtectedRoute>}
          />
        ))}

        <Route path="*" element={<Navigate to="/" />} />
        <Route path="/us" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
